import axios from 'axios'
import { Store } from '../store'
import { Event } from '../data-models/event'

const backendUrl = process.env.VUE_APP_BACKEND

export default {
  methods: {
    fetchUpcomingEvents () {
      return new Promise((resolve, reject) => {
        axios.get(backendUrl + '/events')
          .then(response => resolve(makeEvents(response.data)))
          .catch(reject)
      })
    },
    fetchPastEvents (start = null, end = null, n = null) {
      return new Promise((resolve, reject) => {
        if (end === null) {
          end = todayString()
        }
        let path = '/events?'
        const queryObj = {
          start: start,
          end: end,
          n: n
        }

        Object.keys(queryObj).map(key => {
          if (queryObj[key] !== null) {
            if (!path.endsWith('?')) {
              path += '&'
            }
            path += key + '=' + queryObj[key]
          }
        })

        axios.get(backendUrl + path)
          .then(response => resolve(makeEvents(response.data)))
          .catch(reject)
      })
    },
    fetchRegisteredUsers (event) {
      return new Promise((resolve, reject) => {
        axios.get(backendUrl + `/event/${event.id}/users`)
          .then(response => resolve(response.data))
          .catch(reject)
      })
    },
    checkUserIn (eventId, userId) {
      return new Promise((resolve, reject) => {
        axios.post(backendUrl + `/event/${eventId}/check_in`, {
          user_id: userId
        })
          .then(response => {
            if (response.data.error) {
              reject(response.data)
            } else {
              resolve(response.data)
            }
          })
          .catch(reject)
      })
    },
    checkUserOut (eventId, userId) {
      return new Promise((resolve, reject) => {
        axios.post(backendUrl + `/event/${eventId}/check_out`, {
          user_id: userId
        })
          .then(response => {
            if (response.data.error) {
              reject(response.data)
            } else {
              resolve(response.data)
            }
          })
          .catch(reject)
      })
    }
  },
  created () {
    const name = this.$route.params.name
    if (name) {
      const event = eventsWithName(name)
      // We expect 'event' to have 1 key, as 'name' (e.g. "my-yoga-event")
      // is expected to be unique among events. If there are several matches, one is
      // selected arbitrarily, with Object.keys(event)[0]
      this.event = event[Object.keys(event)[0]]
    }
  }
}

function eventsWithName (urlTitle) {
  return Object.filter(Store.events, event => event.urlTitle === urlTitle)
}

export function checkEventName (to, from, next) {
  const urlTitle = to.params.name
  const matches = eventsWithName(urlTitle)
  const matchIds = Object.keys(matches)

  if (matchIds.length === 0) {
    next('/home', { replace: true })
  } else {
    next()
  }
}

export function postEvent (eventData) {
  let form = new FormData()
  for (const key in eventData) {
    if (!eventData.hasOwnProperty(key)) continue
    let value = eventData[key]
    if (key === 'tags') {
      value = Object.keys(value).join(',')
    }
    form.append(key, value)
  }

  return new Promise((resolve, reject) => {
    axios.post(backendUrl + '/event', form, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(response => {
        if (response.data.error) {
          reject(response.data)
        } else {
          resolve(response.data)
        }
      })
      .catch(reject)
  })
}

function makeEvents (data) {
  let events = {}
  Object.keys(data)
    .map(eventId => {
      events[eventId] = new Event(data[eventId])
      events[eventId].id = eventId
    })
  return events
}

function todayString () {
  const today = new Date()

  // Leave hour and minute as '0000' in result to catch any event today, even if it's passed already
  return [today.getFullYear() % 1000, today.getMonth() + 1, today.getDate(), '', ''].map(s => String(s).padStart(2, '0')).join('')
}
